import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withCtx as _withCtx, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5018fcda"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_mismatched_sku",
  ref: "mismatchedSkuRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-730px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_mismatched_sku_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1))
const _hoisted_8 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body px-17 py-9" }
const _hoisted_11 = { class: "timeline" }
const _hoisted_12 = { class: "timeline-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1))
const _hoisted_14 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_15 = { class: "symbol-label bg-light" }
const _hoisted_16 = { class: "svg-icon svg-icon-1" }
const _hoisted_17 = { class: "timeline-content mb-10 mt-n1" }
const _hoisted_18 = { class: "pe-3 ps-3" }
const _hoisted_19 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex align-items-center fs-6"
}
const _hoisted_21 = { class: "fs-7 text-muted" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "svg-icon svg-icon-2x mx-1" }
const _hoisted_24 = { class: "timeline-item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1))
const _hoisted_26 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_27 = { class: "symbol-label bg-light" }
const _hoisted_28 = { class: "svg-icon svg-icon-1" }
const _hoisted_29 = { class: "timeline-content mb-0 mt-n1 overflow-hidden" }
const _hoisted_30 = { class: "pe-3 ps-3" }
const _hoisted_31 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_32 = { class: "d-flex align-items-center fs-6" }
const _hoisted_33 = { class: "fs-7 text-muted" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = { class: "svg-icon svg-icon-2x mx-1" }
const _hoisted_36 = { class: "pb-5 pt-7" }
const _hoisted_37 = { class: "d-flex flex-column gap-4" }
const _hoisted_38 = { class: "w-100 d-flex flex-column gap-8 lh-sm" }
const _hoisted_39 = { class: "flex-1" }
const _hoisted_40 = { class: "flex-1" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "dataTables_empty h-60px" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-center m-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "No data found")
], -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "d-flex align-items-center mb-3" }
const _hoisted_48 = {
  class: "d-flex align-items-center text-primary cursor-pointer",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_mismatched_pim_sku"
}
const _hoisted_49 = { class: "svg-icon svg-icon-1 svg-icon-primary ms-2" }
const _hoisted_50 = { class: "pt-7" }
const _hoisted_51 = { class: "w-100 d-flex flex-column gap-8 lh-sm" }
const _hoisted_52 = { class: "flex-1" }
const _hoisted_53 = { class: "flex-1" }
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "svg-icon svg-icon-3" }
const _hoisted_57 = { class: "modal-footer align-items-center justify-content-end" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "indicator-label" }
const _hoisted_60 = { class: "svg-icon svg-icon-2" }
const _hoisted_61 = { class: "indicator-progress" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "indicator-label" }
const _hoisted_65 = { class: "svg-icon svg-icon-2" }
const _hoisted_66 = { class: "indicator-progress" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "indicator-label" }
const _hoisted_70 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_71 = { class: "indicator-progress" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_mismatched_pim_sku = _resolveComponent("mismatched-pim-sku")!
  const _component_retour_to_merchant_qty_modal = _resolveComponent("retour-to-merchant-qty-modal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_5, [
                    _createElementVNode("h2", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspection")) + " ", 1),
                      _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.props.scanNumber), 1)
                    ])
                  ]),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t("inspection.skuMismatched")), 1),
                        (_ctx.checkedDate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("inspection.checkedDate", [
                            _ctx.customFormatDateTime(_ctx.checkedDate),
                          ])), 1),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                                ]),
                                _createElementVNode("div", null, _toDisplayString(_ctx.checkedUser), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen012.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.t("inspection.skuMatching")), 1),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.t("inspection.plsSelectMatchedSku")), 1),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("span", _hoisted_35, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                            ]),
                            _createElementVNode("div", null, _toDisplayString(_ctx.userInfo?.username), 1)
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createVNode(_component_el_form_item, { prop: "items" }, null, 512), [
                              [_vShow, 0]
                            ]),
                            _withDirectives(_createVNode(_component_el_form_item, { prop: "mismatched" }, null, 512), [
                              [_vShow, 0]
                            ]),
                            _withDirectives(_createVNode(_component_el_form_item, { prop: "products" }, null, 512), [
                              [_vShow, 0]
                            ]),
                            _withDirectives(_createVNode(_component_el_form_item, { prop: "product_id" }, null, 512), [
                              [_vShow, 0]
                            ]),
                            _createVNode(_component_el_form_item, { prop: "radio" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_38, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.items, (item, index) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      class: "d-flex align-items-center cursor-pointer",
                                      key: index
                                    }, [
                                      _createElementVNode("div", _hoisted_39, [
                                        _createVNode(_component_product_info, {
                                          gallery: item.gallery,
                                          name: item.name,
                                          name_en: item.name_en,
                                          source_link: '',
                                          brand_id: item.__show.brand_id
                                        }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                                      ]),
                                      _createElementVNode("div", _hoisted_40, [
                                        _createVNode(_component_sku_info, {
                                          brand_article_no: item.brand_article_no,
                                          color: item.__show.color,
                                          size: item.__show.size,
                                          product_identifier_id: '0'
                                        }, null, 8, ["brand_article_no", "color", "size"])
                                      ]),
                                      _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("span", _hoisted_42, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "radio",
                                            name: "mismatchedSku",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.radio) = $event)),
                                            value: item.sku_identifier
                                          }, null, 8, _hoisted_43), [
                                            [_vModelRadio, _ctx.formData.radio]
                                          ])
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_44, _hoisted_46, 512), [
                                  [_vShow, _ctx.formData.items.length === 0]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.noMatchingFound")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.noMatchingFoundSelect")), 1),
                            _createElementVNode("span", _hoisted_49, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr001.svg" })
                            ])
                          ])
                        ])
                      ], 512), [
                        [_vShow, !_ctx.formData.product_id]
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.products, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-flex align-items-center",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createVNode(_component_product_info, {
                                    gallery: item.gallery,
                                    name: item.name,
                                    name_en: item.name_en,
                                    source_link: item.source_link,
                                    brand_id: item.__show.brand_id
                                  }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createVNode(_component_sku_info, {
                                    brand_article_no: item.brand_article_no,
                                    color: item.original_color,
                                    size: item.__show.size,
                                    product_identifier_id: 
                                item.product_identifier_id
                              
                                  }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-icon btn-light-danger btn-sm",
                                    onClick: ($event: any) => (_ctx.removeProductItem(index))
                                  }, [
                                    _createElementVNode("span", _hoisted_56, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr011.svg" })
                                    ])
                                  ], 8, _hoisted_55)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ], 512), [
                        [_vShow, _ctx.formData.product_id]
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_57, [
                (0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      ref: _ctx.submitButton,
                      disabled: _ctx.loading,
                      class: "btn btn-lg btn-light",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitFailed && _ctx.submitFailed(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen040.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.matchingFailed")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_61, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_62
                      ])
                    ], 8, _hoisted_58))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("button", {
                  type: "button",
                  ref: _ctx.submitButton,
                  disabled: _ctx.loading,
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#modal_retour_to_merchant_qty_change",
                  class: "btn btn-lg btn-light"
                }, [
                  _createElementVNode("span", _hoisted_64, [
                    _createElementVNode("span", _hoisted_65, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen040.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.retourToMerchantDescription")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_66, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_67
                  ])
                ], 8, _hoisted_63), [
                  [_vShow, _ctx.isShowRetourToMerchant]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  ref: _ctx.submitButton,
                  disabled: _ctx.loading || _ctx.isDisabledSubmit,
                  class: "btn btn-lg btn-primary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _createElementVNode("span", _hoisted_69, [
                    _createElementVNode("span", _hoisted_70, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_71, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_72
                  ])
                ], 8, _hoisted_68)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ], 512),
    _createVNode(_component_mismatched_pim_sku, {
      scanNumber: String(_ctx.scanNumber),
      onUpdateList: _ctx.updateSku
    }, null, 8, ["scanNumber", "onUpdateList"]),
    _createVNode(_component_retour_to_merchant_qty_modal, {
      id: String(_ctx.id),
      scanNumber: String(_ctx.scanNumber),
      maxQty: _ctx.getMaxQty,
      onUpdateList: _ctx.qtySubmit
    }, null, 8, ["id", "scanNumber", "maxQty", "onUpdateList"])
  ], 64))
}